import { useEffect, useState, useCallback } from 'react';

export const useToastQueue = (visibleMs: number = 2000) => {
  const [messageQueue, setMessageQueue] = useState<string[]>([]);
  const [currentMessage, setCurrentMessage] = useState<string | null>(null);
  const [showMessage, setShowMessage] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [progress, setProgress] = useState(100);

  const addMessage = useCallback((msg: string) => {
    setMessageQueue((prev) => [...prev, msg]);
  }, []);
  const deleteQueue = useCallback(() => {
      setMessageQueue([]);
      setCurrentMessage('');
      setFadeOut(false);
      setShowMessage(false);
    }, []);
  useEffect(() => {
    if (!currentMessage && messageQueue.length > 0) {
      const next = messageQueue[0];
      setCurrentMessage(next);
      setMessageQueue((prev) => prev.slice(1));
    }
  }, [currentMessage, messageQueue]);

  useEffect(() => {
    if (currentMessage) {
      setShowMessage(true);
      setFadeOut(false);
      setProgress(100);

      const interval = setInterval(() => {
        setProgress((prev) => Math.max(prev - 5, 0));
      }, visibleMs / 20);

      const timeout1 = setTimeout(() => setFadeOut(true), visibleMs - 400);
      const timeout2 = setTimeout(() => {
        setShowMessage(false);
        setCurrentMessage(null);
        setFadeOut(false);
        setProgress(100);
      }, visibleMs);

      return () => {
        clearInterval(interval);
        clearTimeout(timeout1);
        clearTimeout(timeout2);
      };
    }
  }, [currentMessage, visibleMs]);

  return {
    showMessage,
    fadeOut,
    progress,
    message: currentMessage,
    addMessage,
    deleteQueue
  };
};
